import Immutable from 'seamless-immutable';
import {
  REQUEST_DEMANDE,
  RECEIVE_DEMANDE,
  FAILURE_DEMANDE
} from '../actions/demande.actions';

const INITIAL_STATE = Immutable({
  failure: false,
  fetching: false,
  data: {}
});
/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
export default function reduce(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_DEMANDE:
      return state.merge({
        fetching: true
      });
    case RECEIVE_DEMANDE:
      return state.merge({
        fetching: false,
        failure: false,
        data: action.payload.demande
      });
    case FAILURE_DEMANDE:
      return state.merge({
        fetching: false,
        failure: true
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/demande.reducer.js